import { render, staticRenderFns } from "./AnnotationBar.vue?vue&type=template&id=0696ae30&scoped=true&"
import script from "./AnnotationBar.vue?vue&type=script&lang=js&"
export * from "./AnnotationBar.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationBar.vue?vue&type=style&index=0&id=0696ae30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0696ae30",
  null
  
)

export default component.exports